
import { Component, Vue } from "vue-property-decorator";
import Tramites from "@/components/Web/Tramites.vue";

@Component({
  components: {
    Tramites
  },
  meta: {
    // sets document title
    title: "Trámites y Servicios - Municipalidad de Maipú",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content:
          "Revisa aquí los trámites y servicios online disponibles para ti."
      },
      keywords: { name: "keywords", content: "Maipú" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class TramitesView extends Vue {
  private mounted() {
    document.title = "Trámites y Servicios - Municipalidad de Maipú";
  }
}
